export enum MessageType {
  success = 'success',
  info = 'info',
  error = 'error',
  warning = 'warning',
}

type State = {
  isOpen: boolean
  title: string
  message: string
  type: MessageType
}

export const initialState: State = {
  isOpen: false,
  title: '',
  message: '',
  type: MessageType.success,
}

enum ActionType {
  show = 'show',
  close = 'close',
}

type Action = {
  type: ActionType
  payload: any
}

export const showAction = (
  title: string,
  message: string,
  type: MessageType
): Action => ({
  type: ActionType.show,
  payload: { title, message, type },
})

export const closeAction = (): Action => ({
  type: ActionType.close,
  payload: null,
})

export function NotificationReducer(state: State, action: Action): State {
  const { type, payload } = action
  switch (type) {
    case ActionType.show:
      return {
        ...state,
        ...payload,
        isOpen: true,
      }
    case ActionType.close:
      return {
        ...state,
        isOpen: false,
        ...payload,
      }
    default:
      return state
  }
}
